export enum InspectionGroupBy {
  Checklist = 'Checklist',
  EntityItem = 'EntityItem',
  Assignee = 'Assignee',
  Category = 'Category',
  Group = 'Group',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
}

export enum GroupByDates {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
}

export enum IssueGroupBy {
  Checklist = 'Checklist',
  EntityItem = 'EntityItem',
  Assignee = 'Assignee',
  Category = 'Category',
  Group = 'Group',
  Question = 'Question',
  Creator = 'Creator',
  Resolver = 'Resolver',
  Priority = 'Priority',
  Inspection = 'Inspection',
  Section = 'Section',
  Sensor = 'Sensor',
  Type = 'Type',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
}

export enum QuestionGroupBy {
  Checklist = 'Checklist',
  EntityItem = 'EntityItem',
  Category = 'Category',
  Group = 'Group',
  Question = 'Question',
  Inspector = 'Inspector',
  Inspection = 'Inspection',
  Section = 'Section',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
}

export type AnalyticsGroupBy = QuestionGroupBy | IssueGroupBy | InspectionGroupBy | GroupByDates;
